/**
 * Auth policy constants shared by the API and the web client (ADR-0027).
 *
 * `PASSWORD_MIN_LENGTH` lives here because it is enforced in two places that
 * cannot import each other: `apps/api/src/auth/password.ts` rejects below it,
 * and `apps/web/src/auth/password-login.tsx` pre-flights against it to spend a
 * keystroke instead of a round trip and an ADR-0011 consecutive-failure slot.
 * `web -> api` is a forbidden edge (plan §3.5a), so before this module the two
 * were independent literals bound by nothing: raising the server floor left
 * BOTH suites green while the form kept accepting passwords the API rejects —
 * burning ban slots on a correct password, with no test failure and no error.
 * `web -> contracts` and `api -> contracts` are both allowed, so one symbol
 * closes the drift without touching the dependency rules.
 *
 * The server remains the authority; this is the number it enforces, not a
 * second opinion about it.
 */

export const PASSWORD_MIN_LENGTH = 12;

/**
 * Upper bound on an accepted password, enforced on BOTH sides for the same
 * reason as the floor.
 *
 * Argon2id does not truncate (that is the bcrypt failure ADR-0027 rejected it
 * for), so without a ceiling the credential field is the one unbounded input in
 * the auth surface — bounded only by the 32 KB `bodyLimit`, which answers with
 * a 413 that the login form can only render as its generic retryable copy. A
 * value that cannot succeed should be rejected where the user can act on it.
 *
 * 128 sits well above OWASP ASVS 2.1.2's "at least 64 characters permitted", so
 * it bounds the field without constraining any passphrase a person would pick.
 */
export const PASSWORD_MAX_LENGTH = 128;
